
const character = () => import('@/pages/system/character/character.vue')
const user = () => import('@/pages/system/user/user.vue')
export default [
    {
        path: 'system/character',
        name:'system/character',
        component: character
    },
    {
        path: 'system/user',
        name:'system/user',
        component: user
    },
]


// WEBPACK FOOTER //
// ./src/router/system.js